import { Button, Card, CardContent, Container, Grid, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Iconify from '../../components/Iconify'
import { FormProvider, RHFTextField } from '../../components/hook-form';
import Page from '../../components/Page'
import { BannerService } from '../../Services/banner.service';

const CreateBanner = ({ bannerr }) => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [banner, setBanner] = useState('');
    const [imageReview, setImageReview] = useState();

    const defaultValues = {
        banner: ''
    };

    const methods = useForm({
        defaultValues,
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const handleOnSubmit = (data) => {
        const form = new FormData();
        form.append('banner', banner);
        // handleStartLoading()
        BannerService.CreateBanner(form)
            .then((res) => {
                navigate('/banner', { replace: true, state: '/banner' });
                enqueueSnackbar('Thêm banner thành công', { variant: 'success' });
            })
            .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
        // .finally(handleStopLoading)
    };

    const handleCancelClick = () => {
        navigate(-1);
    };

    const handleAvatarChange = (e) => {
        try {
            // handleStartLoading()
            const img = e.target.files[0];
            const review = URL.createObjectURL(img);
            setImageReview(review);
            setBanner(img);
        } catch (error) {
            console.log(error)
        }
        // finally {
        //     handleStopLoading()
        // }
    };
    return (
        <Page title="Create event">
            <FormProvider
                methods={methods}
                onSubmit={handleSubmit(handleOnSubmit)}
            >
                <Container>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Thêm banner mới
                        </Typography>
                        <Stack direction={'row'} spacing={1}>
                            <Button
                                type="button"
                                onClick={handleCancelClick}
                                color="error"
                                variant="contained"
                                startIcon={<Iconify icon="iconoir:cancel" />}
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={isSubmitting}
                                // onClick={handleOnSubmit}
                                type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
                                Save
                            </Button>
                        </Stack>
                    </Stack>
                    <Card>
                        <CardContent>
                            <Grid container spacing={3} direction={{ xs: 'column-reverse', md: 'row' }}>

                                <Grid item xs={12} md={4}>
                                    <Button
                                        disabled={isSubmitting}
                                        sx={{ border: '1px dashed gray' }}
                                        color="primary"
                                        aria-label="upload picture"
                                        component="label"
                                    >
                                        <input
                                            onChange={handleAvatarChange}
                                            hidden accept="image/*" type="file" />
                                        {imageReview ? (
                                            <img
                                                src={imageReview}
                                                alt="noimage"
                                                width={'300px'}
                                                height={'180px'}
                                                style={{ objectFit: 'cover' }}
                                            />
                                        ) : (
                                            <img
                                                src="/static/noimage.jpeg"
                                                alt="noimage"
                                                width={'300px'}
                                                height={'180px'}
                                                style={{ objectFit: 'cover' }}
                                            />
                                        )}
                                    </Button>
                                    <Typography variant="body2" display="block" sx={{opacity: '0.6'}}>Kích thước: 1300x720</Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Container>
            </FormProvider>
        </Page>
    )
}

export default CreateBanner